// Manual-сервисы для конструктора шаблонов — предопределённые наборы полей,
// которые заполняются вручную в runtime (без обращения к внешним fetcher'ам).
// Структура response.properties повторяет ответ соответствующего внешнего
// сервиса, чтобы значения этих полей были взаимозаменяемы.
//
// Источник схемы PERSON_INFO_MANUAL: docs/format-fbdflbasic.md (GBDFLBasic).

const COUNTRY_PROPERTIES = {
  code: { type: "string", title: "Код", title_kz: "Код" },
  name: { type: "string", title: "Наименование", title_kz: "Атауы" },
  name_ru: {
    type: "string",
    title: "Наименование на русском языке",
    title_kz: "Орыс тіліндегі атауы",
  },
  name_kk: {
    type: "string",
    title: "Наименование на казахском языке",
    title_kz: "Қазақ тіліндегі атауы",
  },
  change_date: {
    type: "string",
    title: "Дата изменения",
    title_kz: "Өзгерту күні",
  },
};

const PERSON_INFO_MANUAL_RESPONSE = {
  type: "object",
  title: "Сведение о лице",
  title_kz: "Тұлға туралы мәлімет",
  properties: {
    iin: { type: "string", title: "ИИН", title_kz: "ЖСН" },
    first_name: { type: "string", title: "Имя", title_kz: "Аты" },
    last_name: { type: "string", title: "Фамилия", title_kz: "Тегі" },
    middle_name: {
      type: "string",
      title: "Отчество",
      title_kz: "Әкесінің аты",
    },
    birth_date: {
      type: "string",
      title: "Дата рождения",
      title_kz: "Туған күні",
    },
    reg_address: {
      type: "object",
      title: "Адрес регистрации",
      title_kz: "Тіркеу мекенжайы",
      properties: {
        country: {
          type: "object",
          title: "Страна",
          title_kz: "Ел",
          properties: { ...COUNTRY_PROPERTIES },
        },
        district: {
          type: "object",
          title: "Район",
          title_kz: "Аудан",
          properties: { ...COUNTRY_PROPERTIES },
        },
        region: {
          type: "object",
          title: "Область",
          title_kz: "Облыс",
          properties: { ...COUNTRY_PROPERTIES },
        },
        city: { type: "string", title: "Город", title_kz: "Қала" },
        ar_code: { type: "string", title: "Код АР", title_kz: "АР коды" },
        street: { type: "string", title: "Улица", title_kz: "Көше" },
        building: { type: "string", title: "Дом", title_kz: "Үй" },
        begin_date: {
          type: "string",
          title: "Дата выдачи",
          title_kz: "Берілген күні",
        },
        corpus: { type: "string", title: "Корпус", title_kz: "Корпус" },
        flat: { type: "string", title: "Квартира", title_kz: "Пәтер" },
      },
    },
    birth_address: {
      type: "object",
      title: "Адрес рождения",
      title_kz: "Туған жерінің мекенжайы",
      properties: {
        country: {
          type: "object",
          title: "Страна",
          title_kz: "Ел",
          properties: { ...COUNTRY_PROPERTIES },
        },
        district: {
          type: "object",
          title: "Район",
          title_kz: "Аудан",
          properties: { ...COUNTRY_PROPERTIES },
        },
        region: {
          type: "object",
          title: "Регион",
          title_kz: "Өңір",
          properties: { ...COUNTRY_PROPERTIES },
        },
        city: {
          type: "string",
          title: "Населённый пункт",
          title_kz: "Елді мекен",
        },
      },
    },
  },
};

export const MANUAL_SERVICES = [
  {
    code: "manual",
    name: "Сведение о лице (ручной ввод)",
    name_kz: "Тұлға туралы мәлімет (қолмен енгізу)",
    response: PERSON_INFO_MANUAL_RESPONSE,
  },
];

export function getManualService(code) {
  return MANUAL_SERVICES.find((s) => s.code === code) ?? null;
}
